import React, { lazy } from 'react';
import { type RenderFn } from '@atlassian/forge-ui-types';

const AKSpinner = lazy(() => import('@atlaskit/spinner'));

export const Spinner = ({ forgeDoc }: Parameters<RenderFn>[0]) => {
	return <AKSpinner size={forgeDoc.props?.size} />;
};
